/**
 *
 * All regestered route for sidebar only.
 *
 */

 import Dashboard from "views/Dashboard.js";

 import InstrumentIndex from "views/Instrument/Index.js";
 import Agenda from 'views/Agenda/Agenda.js';
 import ScopeIndex from 'views/Scope/Index.js';
 import UserIndex from 'views/User/Index.js';
 import AuditeeIndex from 'views/Auditee/Index.js';
 import StandardIndex from 'views/Standard/Index.js';
 import AuditorIndex from 'views/Auditor/Index.js';
 import ScoreGroup from 'views/ScoreGroup/Index.js';
 import ScoreIndex from 'views/ScoreIndex/Index.js';
 import ScheduleIndex from 'views/Schedule/Index.js';
 import Monitoring from 'views/Audit/Admin/Monitoring.js';

 /** Only handle authenticated user */
 var routes = [
   {
     path: "/dashboard",
     layout: "/manager",
     name: "Dashboard",
     icon: "nc-icon nc-chart-pie-35",
     component: Dashboard,
   },
   {
     collapse: true,
     path: "/master",
     layout: "/manager",
     name: "Master",
     icon: "nc-icon nc-chart-pie-35",
     views: [
       {
         path: "/scope",
         layout: "/manager",
         name: "Scope",
         mini: "S",
         component: ScopeIndex,
       },
       {
         path: "/auditee",
         layout: "/manager",
         name: "Auditee",
         mini: "A",
         component: AuditeeIndex,
       },
       {
         path: "/auditor",
         layout: "/manager",
         name: "Auditor",
         mini: "A",
         component: AuditorIndex,
       },
       {
         path: "/user",
         layout: "/manager",
         name: "User",
         mini: "U",
         component: UserIndex,
       },
       {
         path: "/standard",
         layout: "/manager",
         name: "Standard",
         mini: "S",
         component: StandardIndex,
       },
       {
         path: "/score",
         layout: "/manager",
         name: "Score Group",
         mini: "SG",
         component: ScoreGroup,
       },
       {
         path: "/score-index",
         layout: "/manager",
         name: "Score Index",
         mini: "SI",
         component: ScoreIndex,
       },
     ]
   },
   {
     path: "/instruments",
     layout: "/manager",
     name: "Instruments",
     state: "openComponents",
     icon: "nc-icon nc-app",
     component: InstrumentIndex,
   },
   {
     collapse: true,
     name: "Audit",
     state: "openForms",
     icon: "nc-icon nc-notes",
     views: [
       {
         path: "/schedules",
         layout: "/manager",
         name: "Schedules",
         mini: "S",
         component: ScheduleIndex,
       },
       {
         path: "/monitorings",
         layout: "/manager",
         name: "Monitoring",
         mini: "M",
         component: Monitoring,
       },
     ],
   },
   {
     path: "/agenda",
     layout: "/manager",
     name: "Agenda",
     state: "openTables",
     icon: "nc-icon nc-paper-2",
     component: Agenda,
   },
 ];
 export default routes;
